export const Menu_LIST_REQUEST = 'Menu_LIST_REQUEST';
export const Menu_LIST_SUCCESS = 'Menu_LIST_SUCCESS';
export const Menu_LIST_FAIL = 'Menu_LIST_FAIL';